import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../contexts/AdminAuthContext';
import client from '../api/client';

export default function Candidates() {
  const { admin } = useAdminAuth();
  const navigate = useNavigate();
  const [candidates, setCandidates] = useState([]);
  const [parties, setParties] = useState([]);
  const [constituencies, setConstituencies] = useState([]);
  const [form, setForm] = useState({ name: '', party_id: '', constituency_id: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    if (!admin) { navigate('/admin/login'); return; }
    loadCandidates();
    client.get('/parties').then(res => {
      setParties(res.data.slice(0, 2));
    }).catch(() => {});
    client.get('/admin/constituencies').then(res => setConstituencies(res.data)).catch(() => {});
  }, [admin, navigate]);

  const loadCandidates = () => {
    client.get('/candidates').then(res => setCandidates(res.data)).catch(() => {});
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    setError(''); setSuccess('');
    try {
      await client.post('/candidates', form);
      setSuccess('Candidate added successfully');
      setForm({ name: '', party_id: '', constituency_id: '' });
      loadCandidates();
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to add candidate');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this candidate?')) return;
    try {
      await client.delete(`/candidates/${id}`);
      loadCandidates();
    } catch (err) {
      setError('Failed to delete candidate');
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Candidates</h1>
        <Link to="/admin/dashboard" className="btn-secondary">Back</Link>
      </div>

      <div className="card">
        <h2>Add Candidate</h2>
        {error && <div className="error-msg">{error}</div>}
        {success && <div className="success-msg">{success}</div>}
        <form onSubmit={handleAdd}>
          <div className="form-group">
            <label>Name</label>
            <input
              type="text"
              value={form.name}
              onChange={e => setForm({ ...form, name: e.target.value })}
              required
            />
          </div>
          <div className="form-group">
            <label>Party</label>
            <select
              value={form.party_id}
              onChange={e => setForm({ ...form, party_id: e.target.value })}
              required
            >
              <option value="">Select Party</option>
              {parties.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Constituency</label>
            <select
              value={form.constituency_id}
              onChange={e => setForm({ ...form, constituency_id: e.target.value })}
              required
            >
              <option value="">Select Constituency</option>
              {constituencies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          <button type="submit" className="btn-primary">Add Candidate</button>
        </form>
      </div>

      <div className="table-container">
        <h2>All Candidates ({candidates.length})</h2>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Party</th>
              <th>Constituency</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {candidates.map(c => (
              <tr key={c.id}>
                <td>{c.name}</td>
                <td>{c.party_name}</td>
                <td>{c.constituency_name}</td>
                <td>
                  <button onClick={() => handleDelete(c.id)} className="btn-danger">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
